import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/i18n";
import "@/app/styles.css";

import { App } from "@/app/App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
